import type { RouteDataFunc } from "@solidjs/router";
import { getUserStore } from "~/solidJs/entities/HeaderMain/models";
import { TeamApi } from "~/solidJs/shared/api/TeamApi";
import type { IUser } from "~/solidJs/shared/helpers/types";
import { getUserAndSetStore, isUserInited } from "~/solidJs/shared/helpers/userHelpers";
import { AppSumoApi } from "../[AppSumoCallbackPage]/data";

const updateStoreIfNeedToRegister = async (user: IUser | null) => {
	const results = await Promise.allSettled([
		AppSumoApi.registerAppSumoCode(),
		TeamApi.registerTeamInvitation()
	]);

	// Check if any of the operations succeeded
	const hasSuccess = results.some(
		(result) => result.status === "fulfilled" && result.value === true
	);

	if (hasSuccess) {
		return await getUserAndSetStore();
	}
	return user;
};

export const getUser = async () => {
	let user = getUserStore();
	if (isUserInited(user)) {
		return await updateStoreIfNeedToRegister(user);
	}
	user = await getUserAndSetStore();
	if (user) {
		return await updateStoreIfNeedToRegister(user);
	}
	return user;
};

export const IndexLayoutData: RouteDataFunc = (_props) => {
	return { user: getUser() };
};
